import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import NeedList from './need-list'
import NeedQuestions from './need-questions'
import { getToggles } from 'quick-quote/feature-toggles'
import { Redirect } from 'react-router-dom'
import { ROUTE_PATH } from 'quick-quote/constants/path'
import { useLocation } from 'react-router-dom'
import { isQuickQuotePath } from 'quick-quote/components/navigations/utils'

function Form(props) {
  const location = useLocation()
  const pathname = location.pathname
  const isQQ = isQuickQuotePath(pathname)

  if (isQQ && !props.selectedDisplayProductCode) {
    return <Redirect to="/" push />
  }

  const { selectedNeedId, isUserOnline, isUserLogin, needLogin, setNotification } = props

  useEffect(() => {
    if (getToggles().ENABLE_FORCE_LOGIN_FIRST) {
      if (!isUserOnline) {
        setNotification({ type: 'Warning', subType: 'NoInternet' })
      } else if (!isUserLogin) {
        needLogin()
      }
    }
  }, [isUserOnline, isUserLogin, needLogin, setNotification])

  if (getToggles().ENABLE_FORCE_LOGIN_FIRST) {
    if (!isUserOnline || !isUserLogin) {
      return <Redirect to={ROUTE_PATH.PORTAL} push />
    }
  }

  return (
    <div id="need-gap-form" className="az-need-and-gap">
      <div className="az-need-and-gap__container">
        <NeedList {...props} />
        {selectedNeedId ? <NeedQuestions key={selectedNeedId} {...props} /> : null}
      </div>
    </div>
  )
}

const propTypes = {
  needs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  questions: PropTypes.shape({
    label: PropTypes.string,
    type: PropTypes.string,
  }),
  needPlan: PropTypes.shape({}),
  selectedNeedId: PropTypes.string,
  selectedPlanId: PropTypes.string,
  setSelectedNeedId: PropTypes.func,
  setQuestion: PropTypes.func,
  targetSavings: PropTypes.number,
  needLogin: PropTypes.func,
  setNotification: PropTypes.func,
}
const defaultProps = {
  needs: [],
  questions: {},
  needPlan: {},
  selectedNeedId: '',
  selectedPlanId: '',
  setSelectedNeedId() {},
  setQuestion() {},
  needLogin() {},
  setNotification() {},
}

Form.propTypes = propTypes
Form.defaultProps = defaultProps

export default Form
